<template>
  <div class="text-center py-12">
    <i class="fa-solid fa-inbox text-4xl text-gray-300 mb-4"></i>
    <h3 class="text-lg font-medium text-gray-900 mb-2">Aucun élément trouvé</h3>
    <p class="text-gray-500">
      {{ message }}
    </p>
    <button
      v-if="showBackButton"
      @click="$emit('goBack')"
      class="mt-4 bg-blue-500 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-200 hover:bg-blue-600"
    >
      Retour
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  message: {
    type: String,
    default: 'Aucun élément trouvé.'
  },
  showBackButton: {
    type: Boolean,
    default: false
  }
})

defineEmits(['goBack'])
</script>
